var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazonVpclogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Flow-Logs_48_Light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Resource/Networking-and-Content-Delivery/Res_Amazon-VPC_Flow-Logs_48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2071,24.708 L37.8321,29.083 L36.4181,27.669 L39.0861,25.001 L7.3751,25.001 L7.3751,23.001 L39.0861,23.001 L36.4181,20.332 L37.8321,18.918 L42.2071,23.294 C42.5981,23.685 42.5981,24.317 42.2071,24.708 L42.2071,24.708 Z M17.0001,33.751 L30.1251,33.751 L30.1251,31.751 L17.0001,31.751 L17.0001,33.751 Z M17.0001,29.376 L30.1251,29.376 L30.1251,27.376 L17.0001,27.376 L17.0001,29.376 Z M17.0001,20.625 L30.1251,20.625 L30.1251,18.625 L17.0001,18.625 L17.0001,20.625 Z M17.0001,16.25 L30.1251,16.25 L30.1251,14.25 L17.0001,14.25 L17.0001,16.25 Z M31.7501,26.626 L33.7501,26.626 L33.7501,37.126 C33.7501,37.679 33.3031,38.126 32.7501,38.126 L14.3751,38.126 C13.8221,38.126 13.3751,37.679 13.3751,37.126 L13.3751,26.626 L15.3751,26.626 L15.3751,36.126 L31.7501,36.126 L31.7501,26.626 Z M15.3751,21.375 L13.3751,21.375 L13.3751,10.875 C13.3751,10.322 13.8221,9.875 14.3751,9.875 L32.7501,9.875 C33.3031,9.875 33.7501,10.322 33.7501,10.875 L33.7501,21.375 L31.7501,21.375 L31.7501,11.875 L15.3751,11.875 L15.3751,21.375 Z M24.0001,44.001 C12.9721,44.001 4.0001,35.029 4.0001,24.001 C4.0001,12.973 12.9721,4 24.0001,4 C35.0281,4 44.0001,12.973 44.0001,24.001 C44.0001,35.029 35.0281,44.001 24.0001,44.001 L24.0001,44.001 Z M24.0001,2 C11.8691,2 2.0001,11.869 2.0001,24.001 C2.0001,36.132 11.8691,46.001 24.0001,46.001 C36.1311,46.001 46.0001,36.132 46.0001,24.001 C46.0001,11.869 36.1311,2 24.0001,2 L24.0001,2 Z",
    id: "AWS-Amazon-VPC_Flow-logs_Resource-Icon_light-bg",
    fill: "#4D27AA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonVpclogs);
export default __webpack_public_path__ + "static/media/amazon_vpclogs.a6361309d9b003946aa1ffddbe09b159.svg";
export { ForwardRef as ReactComponent };